import { Button, Link, Text, VStack } from "@chakra-ui/react";
import { ErrorBoundaryFallbackProps } from "@suspensive/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { InternalErrorDetails } from "shared/components/internal/InternalErrorDetails";
import { useHelpButtonOnClick } from "shared/hooks/useHelpButtonOnClick";
import { getApiError } from "shared/utils/ErrorUtils";
import { SetOptional } from "type-fest";

export type GenericErrorViewProps = SetOptional<
  ErrorBoundaryFallbackProps,
  "reset"
>;

export const GenericErrorView: React.FC<GenericErrorViewProps> = ({
  error,
  reset,
}) => {
  const { t } = useTranslation(["common", "auth"]);
  const message = getApiError(error)?.message;
  const onClickHelp = useHelpButtonOnClick();
  return (
    <VStack
      p={6}
      spacing={4}
      flex={1}
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      data-ls-enabled={true}
      data-public={true}
    >
      <Text fontWeight="medium" fontSize="16px">
        {t("common:error.generic")}
      </Text>
      {message ? <Text>{message}</Text> : null}
      <Text>
        <Trans ns="common" i18nKey="error.ifPersistsContactSupport">
          If you need help
          <Link colorScheme="gray" onClick={onClickHelp}>
            contact support
          </Link>
          .
        </Trans>
      </Text>
      <InternalErrorDetails error={error} />
      {reset && (
        <Button size="xs" colorScheme="secondary" onClick={reset}>
          {t("common:tryAgain")}
        </Button>
      )}
    </VStack>
  );
};

export const GenericErrorViewFallback: React.FC<ErrorBoundaryFallbackProps> = (
  props,
) => <GenericErrorView {...props} />;
